import React, { ComponentProps, FC } from 'react';
import { Trans } from '@lingui/react/macro';

import FaqSection from '@rover/components/src/FaqSection';
import LandingFaqList from '@rover/react-lib/src/pages/landing/components/LandingFaq/LandingFaqList';
import type { LandingFAQ } from '@rover/rsdk/src/apiClient/latest/model/landingFAQ';
import useDucks from '@rover/shared/js/hooks/useDucks';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';

import { selectors as homePageSelectors } from '../HomePage.duck';

type Props = Omit<ComponentProps<typeof LandingFaqList>, 'faqs' | 'children'>;

const selector = (state): { faqs: LandingFAQ[] } => ({
  faqs: homePageSelectors.getFaqs(state),
});

const HomePageFaqs: FC<Props> = (sectionProps) => {
  const {
    data: { faqs },
  } = useDucks({ selector });
  const brandDisplayName = getBrandDisplayName();

  return (
    <LandingFaqList faqs={faqs} {...sectionProps}>
      <FaqSection.Header webProps={{ responsive: false }}>
        <Trans>FAQs</Trans>
      </FaqSection.Header>
      <FaqSection.Subheader>
        <Trans>Frequently asked questions about {brandDisplayName}</Trans>
      </FaqSection.Subheader>
    </LandingFaqList>
  );
};

export default HomePageFaqs;
